module.exports = __webpack_public_path__ + "img/image_webinars04@2x.8e0df24e.png";